export const resolveUiLanguage = ({
	defaultUiLanguage,
	isLoginPath = false
}) => {
	if (isLoginPath) {
		return "en"
	}

	return defaultUiLanguage?.toLowerCase() || "en"
}
